function hexToRgba(hex, alpha = 1) {
  hex = hex.replace(/^#/, '');

  if (hex.length === 3) {
    hex = hex.split('').map(char => char + char).join('');
  }

  if (hex.length !== 6) {
    throw new Error('Color HEX inválido');
  }

  const bigint = parseInt(hex, 16);
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;

  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

document.addEventListener('DOMContentLoaded', function () {
  const filterBtn = document.querySelector('.filter_btn h2');
  const filtersContainer = document.getElementById("FacetFiltersForm");
  
  if (filterBtn) {
    const filterMenu = document.querySelector('#main-collection-filters');
    const productGrid = document.querySelector('ul#product-grid');
    
    if (!filterMenu || !productGrid) return;

    const isInitiallyVisible = window.getComputedStyle(filterMenu).display !== 'none';
    
    if (isInitiallyVisible) {
      filterBtn.innerText = 'ocultar filtros';
      filterBtn.classList.add('giraflecha');
    } else {
      filterBtn.innerText = 'ver filtros';
      filterBtn.classList.remove('giraflecha');
    }

    filterBtn.addEventListener('click', function () {
      const isCurrentlyVisible = window.getComputedStyle(filterMenu).display !== 'none';
      
      if (isCurrentlyVisible) {
        this.innerText = 'ver filtros';
        this.classList.remove('giraflecha');
        
        productGrid.classList.add('transitioning');
        filterMenu.classList.add('hiding');
        
        setTimeout(() => {
          if (productGrid.classList.contains('grid--3-col-desktop')) {
            productGrid.classList.replace('grid--3-col-desktop', 'grid--4-col-desktop');
          }
          productGrid.classList.remove('transitioning');
        }, 300);
        
        setTimeout(() => {
          filterMenu.style.display = 'none';
          filterMenu.classList.remove('hiding');
        }, 500);
        
      } else {
        this.innerText = 'ocultar filtros';
        this.classList.add('giraflecha');
        
        filterMenu.style.display = 'block';
        filterMenu.style.maxHeight = filterMenu.scrollHeight + 'px';
        
        productGrid.classList.add('transitioning');
        
        setTimeout(() => {
          if (productGrid.classList.contains('grid--4-col-desktop')) {
            productGrid.classList.replace('grid--4-col-desktop', 'grid--3-col-desktop');
          }
          productGrid.classList.remove('transitioning');
        }, 300);
      }
    });
  }

  function initDraggableScroll() {
    const scrollContainer = document.querySelector(".filtro_tallas ul");
    if (!scrollContainer) return;

    let isDown = false;
    let startX;
    let scrollLeft;

    scrollContainer.addEventListener("mousedown", (e) => {
      isDown = true;
      scrollContainer.classList.add("active");
      startX = e.pageX - scrollContainer.offsetLeft;
      scrollLeft = scrollContainer.scrollLeft;
    });

    scrollContainer.addEventListener("mouseleave", () => {
      isDown = false;
      scrollContainer.classList.remove("active");
    });

    scrollContainer.addEventListener("mouseup", () => {
      isDown = false;
      scrollContainer.classList.remove("active");
    });

    scrollContainer.addEventListener("mousemove", (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - scrollContainer.offsetLeft;
      const walk = (x - startX) * 1;
      scrollContainer.scrollLeft = scrollLeft - walk;
    });

    scrollContainer.addEventListener("touchstart", (e) => {
      startX = e.touches[0].pageX - scrollContainer.offsetLeft;
      scrollLeft = scrollContainer.scrollLeft;
    });

    scrollContainer.addEventListener("touchmove", (e) => {
      const x = e.touches[0].pageX - scrollContainer.offsetLeft;
      const walk = (x - startX) * 1;
      scrollContainer.scrollLeft = scrollLeft - walk;
    });
  }

  initDraggableScroll();

  if (filtersContainer) {
    const observer = new MutationObserver((mutations) => {
      initDraggableScroll();
    });

    observer.observe(filtersContainer, { childList: true, subtree: true });
  }

  const filterHeading = document.querySelector('.facets__heading');
  const filterDetails = document.querySelectorAll('.facets__disclosure-vertical');

  if (filterHeading && filterDetails.length > 0) {
    filterHeading.addEventListener('click', () => {
      filterHeading.classList.toggle('filters-closed');
      filterDetails.forEach((detail) => {
        detail.style.visibility = filterHeading.classList.contains('filters-closed') ? 'hidden' : 'visible';
      });
    });
  }
});

/* PDP thumbnail */

/* Flash sale countdown */
(function () {
  const pad = n => String(n).padStart(2, '0');

  function formatCountdown(ms) {
    if (ms <= 0) return null;
    const days    = Math.floor(ms / 86400000);
    const hours   = Math.floor((ms % 86400000) / 3600000);
    const minutes = Math.floor((ms % 3600000) / 60000);
    const seconds = Math.floor((ms % 60000) / 1000);
    if (days > 0) return `${days}d ${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
    return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
  }

  function updateCountdowns() {
    document.querySelectorAll('[data-expiration]').forEach(el => {
      const expiration = parseInt(el.dataset.expiration, 10) * 1000;
      const remaining  = expiration - Date.now();
      const timer      = el.querySelector('.sale-countdown__timer');
      if (!timer) return;
      const formatted  = formatCountdown(remaining);
      if (!formatted) {
        el.style.display = 'none';
      } else {
        timer.textContent = formatted;
      }
    });
  }

  updateCountdowns();
  setInterval(updateCountdowns, 1000);
})();

(function () {
  const SCROLL_PX_PER_S = 40;
  const TRANSITION_MS   = 200;

  function teardownMarquee(wrapper) {
    const track = wrapper.querySelector('.icon-bar__marquee-track');
    if (track) {
      const orig = track.querySelector('.icon-bar__text');
      if (orig) wrapper.appendChild(orig);
      track.remove();
    }
    wrapper.classList.remove('icon-bar__text-wrapper--marquee');
    delete wrapper.dataset.marqueeChecked;
  }

  function buildMarquee(item) {
    const wrapper = item.querySelector('.icon-bar__text-wrapper');
    const textEl  = wrapper && wrapper.querySelector('.icon-bar__text');
    if (!wrapper || !textEl || wrapper.dataset.marqueeChecked) return null;
    wrapper.dataset.marqueeChecked = '1';

    const textWidth    = textEl.scrollWidth;
    const wrapperWidth = wrapper.clientWidth;

    if (textWidth <= wrapperWidth + 1) return null;

    item.classList.add('icon-bar__mobile-item--marquee');

    const rootFs = parseFloat(getComputedStyle(document.documentElement).fontSize) || 16;
    const gap    = 3 * rootFs;
    const dist   = textWidth + gap;
    const durMs  = Math.ceil(dist / SCROLL_PX_PER_S * 1000);

    const clone  = textEl.cloneNode(true);
    const track  = document.createElement('span');
    track.className = 'icon-bar__marquee-track';
    track.appendChild(textEl);
    track.appendChild(clone);
    wrapper.appendChild(track);
    track.style.setProperty('--marquee-dist',     dist  + 'px');
    track.style.setProperty('--marquee-duration', durMs + 'ms');
    wrapper.classList.add('icon-bar__text-wrapper--marquee');

    return durMs;
  }

  function startMarquee(item) {
    const wrapper = item.querySelector('.icon-bar__text-wrapper--marquee');
    if (!wrapper) return;
    const track = wrapper.querySelector('.icon-bar__marquee-track');
    if (!track) return;
    wrapper.classList.remove('icon-bar__text-wrapper--marquee');
    void track.offsetWidth;
    wrapper.classList.add('icon-bar__text-wrapper--marquee');
    track.style.animationPlayState = 'running';
  }

  function pauseMarquee(item) {
    const track = item.querySelector('.icon-bar__marquee-track');
    if (track) track.style.animationPlayState = 'paused';
  }

  function initIconBarSlider(slider) {
    if (slider._iconBarDestroy) slider._iconBarDestroy();

    const items   = Array.from(slider.querySelectorAll('.icon-bar__mobile-item'));
    if (!items.length) return;

    const prevBtn  = slider.querySelector('.icon-bar__prev');
    const nextBtn  = slider.querySelector('.icon-bar__next');
    const autoplay = slider.dataset.autoplay === 'true';
    const baseMs   = parseInt(slider.dataset.speed || '5', 10) * 1000;
    const durations = items.map(function (item) {
      const marqMs = buildMarquee(item);
      return marqMs !== null ? Math.max(baseMs, marqMs) : baseMs;
    });

    let current    = 0;
    let slideTimer = null;

    function scheduleNext() {
      clearTimeout(slideTimer);
      slideTimer = setTimeout(function () { go(current + 1); }, durations[current]);
    }

    function go(idx) {
      clearTimeout(slideTimer);
      const prev = current;
      current = (idx + items.length) % items.length;
      items[prev].classList.add('is-leaving');
      pauseMarquee(items[prev]);
      items[current].classList.add('is-active');
      startMarquee(items[current]);
      setTimeout(function () {
        items[prev].classList.remove('is-active', 'is-leaving');
        if (autoplay && items.length > 1) scheduleNext();
      }, TRANSITION_MS);
    }

    startMarquee(items[0]);
    if (autoplay && items.length > 1) scheduleNext();

    function onPrev() { go(current - 1); }
    function onNext() { go(current + 1); }
    if (prevBtn) prevBtn.addEventListener('click', onPrev);
    if (nextBtn) nextBtn.addEventListener('click', onNext);

    function onMouseEnter() { clearTimeout(slideTimer); }
    function onMouseLeave() { if (autoplay && items.length > 1) scheduleNext(); }
    slider.addEventListener('mouseenter', onMouseEnter);
    slider.addEventListener('mouseleave', onMouseLeave);

    let lastWidth = slider.offsetWidth;
    let roTimer   = null;
    const ro = new ResizeObserver(function (entries) {
      const newW = Math.round(entries[0] ? entries[0].target.offsetWidth : slider.offsetWidth);
      if (newW === Math.round(lastWidth)) return;
      lastWidth = newW;
      ro.disconnect();
      clearTimeout(roTimer);
      roTimer = setTimeout(function () {
        if (getComputedStyle(slider).display !== 'none') {
          initIconBarSlider(slider);
        } else {
          ro.observe(slider);
        }
      }, 200);
    });
    ro.observe(slider);

    slider._iconBarDestroy = function () {
      clearTimeout(slideTimer);
      clearTimeout(roTimer);
      ro.disconnect();
      if (prevBtn) prevBtn.removeEventListener('click', onPrev);
      if (nextBtn) nextBtn.removeEventListener('click', onNext);
      slider.removeEventListener('mouseenter', onMouseEnter);
      slider.removeEventListener('mouseleave', onMouseLeave);
      items.forEach(function (item) {
        item.classList.remove('icon-bar__mobile-item--marquee', 'is-leaving');
        item.classList.toggle('is-active', item === items[0]);
        const w = item.querySelector('.icon-bar__text-wrapper');
        if (w) teardownMarquee(w);
      });
      delete slider._iconBarDestroy;
    };
  }

  function initAll(root) {
    (root || document).querySelectorAll('.icon-bar__mobile-slider').forEach(initIconBarSlider);
  }

  document.addEventListener('DOMContentLoaded', function () { initAll(); });
  document.addEventListener('shopify:section:load',   function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    e.target.querySelectorAll('.icon-bar__mobile-slider').forEach(function (s) {
      if (s._iconBarDestroy) s._iconBarDestroy();
    });
  });
})();

function closeSizeSelector(card) {
  const sel = card.querySelector('[data-selector="size"]');
  const btn = card.querySelector('[data-action="toggle-selector"]');
  if (sel) sel.style.display = 'none';
  if (btn) btn.style.visibility = 'visible';
}

function closeAllSizeSelectors(exceptCard) {
  document.querySelectorAll('.product-variant-selector.selector-size').forEach(function(sel) {
    if (sel.style.display === 'block') {
      const card = sel.closest('.product-card-wrapper');
      if (card && card !== exceptCard) closeSizeSelector(card);
    }
  });
}

document.addEventListener('click', function(e) {
  const toggle = e.target.closest('[data-action="toggle-selector"]');
  if (toggle) {
    const card = toggle.closest('.product-card-wrapper');
    closeAllSizeSelectors(card);
  }
}, true);

function updateDiscountBadge(badgeContainer, price, comparePrice) {
  if (!badgeContainer) return;

  const existing = badgeContainer.querySelector('.color-badge-pinflag');
  if (existing) existing.remove();

  const discountPercentage = Math.round(((comparePrice - price) / comparePrice) * 100);

  const saleBadge = document.createElement('span');
  saleBadge.className = 'badge badge--bottom-left color-badge-pinflag';

  const s = window.saleBadgeSettings;
  if (s) {
    saleBadge.style.backgroundColor = s.bgColor;
    saleBadge.style.color           = s.textColor;
    saleBadge.style.fontSize        = s.fontSize;
    saleBadge.style.borderRadius    = s.borderRadius;
  }

  saleBadge.textContent = `-${discountPercentage}%`;
  badgeContainer.appendChild(saleBadge);
}

(function () {
  var startX, startY, isHorizontal;

  function onTouchStart(e) {
    if (!e.target.closest('.cart-recommendations-table-mobile')) return;
    startX = e.touches[0].clientX;
    startY = e.touches[0].clientY;
    isHorizontal = null;
  }

  function onTouchMove(e) {
    if (!e.target.closest('.cart-recommendations-table-mobile')) return;
    if (isHorizontal === null) {
      var dx = Math.abs(e.touches[0].clientX - startX);
      var dy = Math.abs(e.touches[0].clientY - startY);
      isHorizontal = dx > dy;
    }
    if (!isHorizontal && e.cancelable) e.preventDefault();
  }

  function attachSliderLock() {
    var cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer || cartDrawer.dataset.sliderLocked) return;
    cartDrawer.dataset.sliderLocked = '';
    cartDrawer.addEventListener('touchstart', onTouchStart, { passive: true });
    cartDrawer.addEventListener('touchmove', onTouchMove, { passive: false });
  }

  document.addEventListener('DOMContentLoaded', attachSliderLock);
})();

/* Cart Promo — slider y agregar producto */
function cartPromoSlide(button, direction) {
  var wrapper = button.closest('.cart-promo__slider-wrapper');
  if (!wrapper) return;
  var track = wrapper.querySelector('.cart-promo__products');
  if (!track) return;
  var card = track.querySelector('.cart-recommendations-cart-item');
  if (!card) return;
  track.scrollBy({ left: direction * (card.offsetWidth + 8), behavior: 'smooth' });
  setTimeout(function () { cartPromoUpdateArrows(wrapper); }, 350);
}

function cartPromoUpdateArrows(wrapper) {
  var track = wrapper.querySelector('.cart-promo__products');
  var prev  = wrapper.querySelector('.cart-promo__arrow--prev');
  var next  = wrapper.querySelector('.cart-promo__arrow--next');
  if (!track || !prev || !next) return;
  prev.disabled = track.scrollLeft <= 4;
  next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
}

/* Cart Promo Bar — actualización dinámica */
(function () {
  function formatMoney(cents, format) {
    var amount = Math.round(cents / 100);
    return format.replace(/\{\{[\w_]+\}\}/g, amount.toLocaleString('es-CL'));
  }

  var _lastPromoTotal = -1;
  var _promoDebounce;

  function updatePromoBar() {
    clearTimeout(_promoDebounce);
    _promoDebounce = setTimeout(doPromoUpdate, 200);
  }

  function doPromoUpdate() {
    var bar = document.querySelector('.cart-promo-bar');
    if (!bar) return;
    var promoMin = parseInt(bar.dataset.promoMin, 10) || 0;
    if (!promoMin) return;
    var moneyFormat = bar.dataset.moneyFormat || '${{amount}}';
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var total = cart.total_price;
        if (total === _lastPromoTotal) return;
        _lastPromoTotal = total;
        var unlocked = total >= promoMin;
        var pct      = unlocked ? 100 : Math.floor(total * 100 / promoMin);
        var fill     = bar.querySelector('.cart-promo-bar__fill');
        var text     = bar.querySelector('.cart-promo-bar__text');
        if (fill) fill.style.width = pct + '%';
        if (!text) return;
        var badge     = bar.dataset.promoBadge || '';
        var badgeHtml = badge ? '&nbsp;<span class="cart-promo-bar__badge">' + badge + '</span>' : '';
        if (unlocked) {
          text.classList.add('cart-promo-bar__text--done');
          var heading   = bar.dataset.promoHeading || '';
          var sep       = (heading && badge) ? ' &mdash; ' : '';
          var badgePart = badge ? '<strong>' + badge + '</strong>' : '';
          text.innerHTML = heading + sep + badgePart + '&nbsp;<svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>';
        } else {
          text.classList.remove('cart-promo-bar__text--done');
          var remaining = promoMin - total;
          var remainingFormatted = formatMoney(remaining, moneyFormat);
          var template = bar.dataset.promoText;
          text.innerHTML = template
            ? template.replace('{amount}', '<strong>' + remainingFormatted + '</strong>') + badgeHtml
            : 'Te faltan <strong>' + remainingFormatted + '</strong> para obtener' + badgeHtml;
        }
      })
      .catch(function () {});
  }

  window._refreshPromoBar = function () {
    _lastPromoTotal = -1;
    updatePromoBar();
  };

  function attachPromoObserver() {
    updatePromoBar();
    var target = document.querySelector('cart-drawer') || document.getElementById('CartDrawer') || document.body;
    new MutationObserver(updatePromoBar).observe(target, { childList: true, subtree: true });
    document.addEventListener('cart:refresh', window._refreshPromoBar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachPromoObserver);
  } else {
    attachPromoObserver();
  }
})();

/* Free Shipping Bar — lógica multi-nivel */
(function () {
  var FSB_KEY = 'pf_fsb_zone';
  var _fsbDebounce;
  var _lastTotal = null;

  function applyZone(fsb, zone) {
    fsb.setAttribute('data-zone', zone);
  }

  function fsbFormatMoney(cents, format) {
    var amount = Math.round(cents / 100);
    return format.replace(/\{\{[\w_]+\}\}/g, amount.toLocaleString('es-CL'));
  }

  function renderFSB(fsb, total) {
    var t1 = parseInt(fsb.dataset.threshold1, 10) || 0;
    var t2 = parseInt(fsb.dataset.threshold2, 10) || 0;
    var fillColor             = fsb.dataset.fill || '#121212';
    var doneColor             = fsb.dataset.fillDone || '#2e7d32';
    var textIncomplete        = fsb.dataset.text || '';
    var textDone              = fsb.dataset.textDone || '';
    var moneyFmt              = fsb.dataset.moneyFormat || '';
    var discountEnabled       = fsb.dataset.discountEnabled === 'true';
    var dt                    = parseInt(fsb.dataset.discountThreshold, 10) || 0;
    var discountTextIncomplete = fsb.dataset.discountText || '';
    var discountTextDone      = fsb.dataset.discountTextDone || '';
    var discountTextFinal     = fsb.dataset.discountTextFinal || discountTextDone;
    var tier2Enabled          = fsb.dataset.tier2Enabled === 'true';
    var tier2Threshold        = parseInt(fsb.dataset.tier2Threshold, 10) || 0;
    var tier2TextIncomplete   = fsb.dataset.tier2Text || '';
    var tier2TextDone         = fsb.dataset.tier2TextDone || '';

    var activeZone      = parseInt(fsb.getAttribute('data-zone'), 10) || 1;
    var activeThreshold = activeZone === 1 ? t1 : t2;
    var shippingDone    = activeThreshold > 0 && total >= activeThreshold;
    var discountDone    = discountEnabled && dt > 0 && total >= dt;
    var tier2Done       = tier2Enabled && tier2Threshold > 0 && total >= tier2Threshold;

    var msg, progress, fillClr, remaining;

    if (tier2Done) {
      progress = 100;
      fillClr  = doneColor;
      msg      = tier2TextDone;
    } else if (tier2Enabled && tier2Threshold > 0 && (discountDone || (!discountEnabled && shippingDone))) {
      remaining = Math.max(0, tier2Threshold - total);
      progress  = Math.min(100, Math.floor(total * 100 / tier2Threshold));
      fillClr   = fillColor;
      msg       = tier2TextIncomplete.replace('[amount]', '<strong>' + fsbFormatMoney(remaining, moneyFmt) + '</strong>');
    } else if (discountDone) {
      progress = 100;
      fillClr  = doneColor;
      msg      = discountTextFinal.replace('[amount]', '<strong>' + fsbFormatMoney(0, moneyFmt) + '</strong>');
    } else if (discountEnabled && dt > 0 && shippingDone) {
      remaining = Math.max(0, dt - total);
      progress  = Math.min(100, Math.floor(total * 100 / dt));
      fillClr   = fillColor;
      msg       = discountTextIncomplete.replace('[amount]', '<strong>' + fsbFormatMoney(remaining, moneyFmt) + '</strong>');
    } else if (shippingDone) {
      progress = 100;
      fillClr  = doneColor;
      msg      = textDone;
    } else {
      remaining = activeThreshold > 0 ? Math.max(0, activeThreshold - total) : 0;
      progress  = activeThreshold > 0 ? Math.min(100, Math.floor(total * 100 / activeThreshold)) : 0;
      fillClr   = fillColor;
      msg       = activeThreshold > 0
        ? textIncomplete.replace('[amount]', '<strong>' + fsbFormatMoney(remaining, moneyFmt) + '</strong>')
        : '';
    }

    var msgEl   = fsb.querySelector('.fsb__message');
    var fillEl  = fsb.querySelector('.fsb__fill');
    var trackEl = fsb.querySelector('.fsb__track');

    if (msgEl)   msgEl.innerHTML = msg;
    if (fillEl) {
      fillEl.style.width           = progress + '%';
      fillEl.style.backgroundColor = fillClr;
    }
    if (trackEl) trackEl.setAttribute('aria-valuenow', progress);

    fsb.classList.remove('fsb--loading');
  }

  function updateFSBProgress(delay) {
    clearTimeout(_fsbDebounce);
    _fsbDebounce = setTimeout(function () {
      if (!document.querySelector('.fsb')) return;
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          _lastTotal = cart.items_subtotal_price != null ? cart.items_subtotal_price : cart.total_price;
          document.querySelectorAll('.fsb').forEach(function (el) { renderFSB(el, _lastTotal); });
        })
        .catch(function () {});
    }, delay != null ? delay : 200);
  }

  function initFSB(fsb) {
    if (fsb._fsbReady) return;
    fsb._fsbReady = true;
    applyZone(fsb, localStorage.getItem(FSB_KEY) || '1');
    var liquidTotal = parseInt(fsb.dataset.cartTotal, 10);
    if (!isNaN(liquidTotal)) _lastTotal = liquidTotal;
    if (_lastTotal !== null) renderFSB(fsb, _lastTotal);
    fsb.querySelectorAll('.fsb__btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var z = btn.getAttribute('data-zone');
        localStorage.setItem(FSB_KEY, z);
        document.querySelectorAll('.fsb').forEach(function (el) {
          applyZone(el, z);
          if (_lastTotal !== null) renderFSB(el, _lastTotal);
        });
        updateFSBProgress();
      });
    });
  }

  window._fsbScan = function () { document.querySelectorAll('.fsb').forEach(initFSB); };
  window._updateFSBProgress = updateFSBProgress;

  document.addEventListener('DOMContentLoaded', function () {
    window._fsbScan();
    var obs = new MutationObserver(window._fsbScan);
    document.querySelectorAll('#CartDrawer, .cart__footer').forEach(function (el) {
      obs.observe(el, { childList: true, subtree: true });
    });
  });
})();

/* Recomendados — solo un selector abierto a la vez */
(function () {
  function closeRecSelector(item) {
    var addBtn  = item.querySelector('.cart-recommendations-button-add');
    var sizeBtn = item.querySelector('.select-size-button');
    var bagMsg  = item.querySelector('.cart-recommendations-bag-message');
    if (!bagMsg) return;
    addBtn  && addBtn.setAttribute('style', 'display: none !important;');
    sizeBtn && sizeBtn.setAttribute('style', 'visibility: visible !important;');
    bagMsg.setAttribute('style', 'display: none !important;');
  }

  function initRecItem(item) {
    if (item._recInited) return;
    item._recInited = true;
    var sizeBtn = item.querySelector('.select-size-button');
    if (!sizeBtn) return;
    sizeBtn.addEventListener('click', function () {
      document.querySelectorAll('.cart-recommendations-cart-item').forEach(function (other) {
        if (other !== item) closeRecSelector(other);
      });
    }, true);
  }

  function scanRecItems() {
    document.querySelectorAll('.cart-recommendations-cart-item').forEach(initRecItem);
  }

  new MutationObserver(scanRecItems).observe(document.body, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scanRecItems);
  } else {
    scanRecItems();
  }
})();

(function () {
  if (!/^\/collections\//.test(window.location.pathname)) return;
  var params = new URLSearchParams(window.location.search);
  if (params.has('filter.v.availability')) return;
  var hasOtherFilters = false;
  params.forEach(function (value, key) {
    if (key.indexOf('filter.') === 0) hasOtherFilters = true;
  });
  if (!hasOtherFilters) return;
  params.set('filter.v.availability', '1');
  window.location.replace(window.location.pathname + '?' + params.toString() + window.location.hash);
})();

(() => {
  const dataEl = document.getElementById('talla-translator-data');
  if (!dataEl) return;

  let allMaps;
  try { allMaps = JSON.parse(dataEl.dataset.tallaMaps); } catch { return; }
  if (!Array.isArray(allMaps) || !allMaps.length) return;

  const usToEurs = {};
  const eurToUs = {};

  for (const map of allMaps) {
    if (!map || typeof map !== 'object') continue;
    for (const [us, eur] of Object.entries(map)) {
      const usStr = String(us);
      const eurStr = String(eur);
      if (!usToEurs[usStr]) usToEurs[usStr] = [];
      if (!usToEurs[usStr].includes(eurStr)) usToEurs[usStr].push(eurStr);
      if (!eurToUs[eurStr]) eurToUs[eurStr] = [];
      if (!eurToUs[eurStr].includes(usStr)) eurToUs[eurStr].push(usStr);
    }
  }

  const usKeys = Object.keys(usToEurs);
  if (!usKeys.length) return;

  let _eurForRep = {};
  let _nativeEur = {};

  const isTallaInput = (input) =>
    input.type === 'checkbox' && input.name && input.name.includes('tallameli');

  const hasAnyNativeEur = (usVal) =>
    (usToEurs[usVal] || []).some(eur => _nativeEur[eur]);

  const tallaSelector = '#FacetFiltersForm input[type="checkbox"], #FacetFiltersFormMobile input[type="checkbox"]';

  function applyTranslator() {
    if (_observer) _observer.disconnect();

    document.querySelectorAll(tallaSelector).forEach(input => {
      if (!isTallaInput(input) || !usKeys.includes(input.value)) return;
      const li = input.closest('li');
      if (li) li.style.display = 'none';
    });

    const nativeEur = {};
    document.querySelectorAll(tallaSelector).forEach(input => {
      if (isTallaInput(input) && !usKeys.includes(input.value)) {
        nativeEur[input.value] = true;
      }
    });
    _nativeEur = nativeEur;

    if (!Object.keys(nativeEur).length) return;

    const eurForRep = {};
    const repForEur = {};

    const orphanEurs = Object.keys(eurToUs)
      .filter(eur => !nativeEur[eur])
      .sort((a, b) => parseFloat(a) - parseFloat(b));

    for (const eur of orphanEurs) {
      const eurNum = parseFloat(eur);
      if (eurNum % 1 !== 0 && nativeEur[String(Math.floor(eurNum))]) continue;

      const candidates = eurToUs[eur] || [];
      let rep = null;

      for (const us of candidates) {
        if (eurForRep[us]) continue;
        if (!hasAnyNativeEur(us)) { rep = us; break; }
      }

      if (!rep) {
        for (const us of candidates) {
          if (eurForRep[us]) continue;
          const usedByNative = Object.keys(nativeEur).some(
            natEur => (eurToUs[natEur] || []).includes(us)
          );
          if (!usedByNative) { rep = us; break; }
        }
      }

      if (rep) {
        repForEur[eur] = rep;
        eurForRep[rep] = eur;
      }
    }

    _eurForRep = eurForRep;

    document.querySelectorAll(tallaSelector).forEach(input => {
      if (!isTallaInput(input) || !usKeys.includes(input.value)) return;
      const eur = eurForRep[input.value];
      if (!eur) return;
      const li = input.closest('li');
      if (!li) return;
      li.style.display = '';
      const labelEl = li.querySelector('.facet-checkbox__text-label');
      if (labelEl && labelEl.textContent !== eur) labelEl.textContent = eur;
    });

    document.querySelectorAll('.active-facets a[data-facet-value]').forEach(a => {
      const facetVal = a.dataset.facetValue;
      if (!usKeys.includes(facetVal)) return;
      const pill = a.closest('facet-remove');
      if (!pill) return;
      const eur = eurForRep[facetVal];
      if (eur) {
        pill.style.display = '';
        const btnInner = pill.querySelector('.active-facets__button-inner');
        if (btnInner) {
          btnInner.childNodes.forEach(node => {
            if (node.nodeType === 3 && node.textContent.includes(facetVal)) {
              node.textContent = node.textContent.replace(facetVal, eur);
            }
          });
        }
      } else {
        pill.style.display = 'none';
      }
    });

    for (const formId of ['FacetFiltersForm', 'FacetFiltersFormMobile']) {
      const form = document.getElementById(formId);
      if (!form) continue;
      form.querySelectorAll('ul').forEach(ul => {
        const items = [...ul.children];
        if (!items.some(el => el.querySelector?.('input[name*="tallameli"]'))) return;
        items.sort((a, b) => {
          const aNum = parseFloat(a.querySelector?.('.facet-checkbox__text-label')?.textContent);
          const bNum = parseFloat(b.querySelector?.('.facet-checkbox__text-label')?.textContent);
          return (!isNaN(aNum) && !isNaN(bNum)) ? aNum - bNum : 0;
        });
        items.forEach(li => ul.appendChild(li));
      });
    }

    const facetsEl = document.getElementById('main-collection-filters');
    if (facetsEl && _observer) _observer.observe(facetsEl, { childList: true, subtree: true });
  }

  const halfGroupUs = (eur) => {
    const n = parseFloat(eur);
    if (!Number.isInteger(n)) return [];
    const half = String(n + 0.5);
    return _nativeEur[half] ? [] : (eurToUs[half] || []);
  };

  function syncPairedTallas(e) {
    const input = e.target;
    if (!isTallaInput(input)) return;
    const form = input.closest('form');
    if (!form) return;

    const setChecked = (us) => {
      form.querySelectorAll('input[type="checkbox"]').forEach(paired => {
        if (isTallaInput(paired) && paired.value === us && paired !== input) {
          paired.checked = input.checked;
        }
      });
    };

    if (!usKeys.includes(input.value)) {
      [...(eurToUs[input.value] || []), ...halfGroupUs(input.value)].forEach(setChecked);
    } else if (_eurForRep[input.value]) {
      const eur = _eurForRep[input.value];
      [...(eurToUs[eur] || []), ...halfGroupUs(eur)].forEach(us => {
        if (us === input.value) return;
        form.querySelectorAll('input[type="checkbox"]').forEach(paired => {
          if (isTallaInput(paired) && paired.value === us) {
            paired.checked = input.checked;
          }
        });
      });
    }
  }

  document.addEventListener('change', syncPairedTallas);
  document.addEventListener('input', syncPairedTallas);

  document.addEventListener('click', e => {
    const link = e.target.closest('facet-remove a[data-facet-value]');
    if (!link) return;
    const facetValue = link.dataset.facetValue;
    let toRemove = [];

    if (!usKeys.includes(facetValue)) {
      toRemove = [...(eurToUs[facetValue] || []), ...halfGroupUs(facetValue)];
    } else if (_eurForRep[facetValue]) {
      const eur = _eurForRep[facetValue];
      toRemove = [...(eurToUs[eur] || []), ...halfGroupUs(eur)].filter(us => us !== facetValue);
    }

    if (!toRemove.length) return;
    const href = link.getAttribute('href');
    if (!href) return;
    try {
      const inp = document.querySelector('input[type="checkbox"][name*="tallameli"]');
      const paramName = inp ? inp.name : 'filter.v.option.tallameli';
      const url = new URL(href, window.location.href);
      toRemove.forEach(us => {
        const vals = url.searchParams.getAll(paramName);
        url.searchParams.delete(paramName);
        vals.forEach(v => { if (v !== us) url.searchParams.append(paramName, v); });
      });
      link.setAttribute('href', url.pathname + url.search);
    } catch {}
  }, true);

  let _applyTimer;
  let _observer = null;

  const scheduleApply = () => {
    clearTimeout(_applyTimer);
    _applyTimer = setTimeout(applyTranslator, 50);
  };

  function init() {
    const facetsEl = document.getElementById('main-collection-filters');
    if (facetsEl) _observer = new MutationObserver(scheduleApply);
    applyTranslator();
    if (facetsEl && _observer) _observer.observe(facetsEl, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

(function () {
  function fmtCLP(amount) {
    return '$' + parseInt(amount).toLocaleString('es-CL');
  }

  function buildRecCard(p) {
    var firstAvail = p.variants.find(function (v) { return v.available; }) || p.variants[0];
    var fi = p.featured_image;
    var rawSrc = fi
      ? (typeof fi === 'object' ? (fi.src || '') : String(fi))
      : (p.images && p.images.length ? (p.images[0].src || '') : '');
    var imgSrc = rawSrc ? rawSrc.replace(/(\.\w+)(\?[^?]*)?$/, '_300x$1$2') : '';
    var url = '/products/' + p.handle;

    var variantBtns = p.variants.map(function (v) {
      var sel = v.id === firstAvail.id ? 'selected' : '';
      var sold = v.available ? '' : 'soldout';
      var dis = v.available ? '' : 'disabled';
      return '<button type="button" class="variant-button variant-button-recommended ' + sel + ' ' + sold + '" data-variant-id="' + v.id + '" onclick="updateSelectedVariant(this,true)" ' + dis + '>' + v.title + '</button>';
    }).join('');

    var priceHtml = (firstAvail.compare_at_price && parseInt(firstAvail.compare_at_price) > parseInt(firstAvail.price))
      ? '<span class="price-item price-item--sale">' + fmtCLP(firstAvail.price) + '</span>&nbsp;<s class="price-item price-item--regular">' + fmtCLP(firstAvail.compare_at_price) + '</s>'
      : '<span class="price-item price-item--regular">' + fmtCLP(firstAvail.price) + '</span>';

    var closeIcon = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" width="15" height="auto" fill="#515151"><path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"/></svg>';

    return '<div class="cart-recommendations-cart-item">' +
      '<div class="cart-item__media cart-recommendations-media" role="cell">' +
        (imgSrc ? '<a href="' + url + '" class="cart-item__link" tabindex="-1" aria-hidden="true"> </a><img class="cart-item__image" src="' + imgSrc + '" alt="' + p.title + '" loading="eager" width="150">' : '') +
      '</div>' +
      '<div class="cart-recommendations-info-container">' +
        '<div class="product-content product-content-recommended"><a href="' + url + '" class="link product-title cart-item__name h4 break labelfied link-recommendation">' + p.title + '</a></div>' +
        '<div class="cart-recommendations-price-container"><div class="price">' + priceHtml + '</div></div>' +
        '<div class="actions-recommended">' +
          '<div class="cart-recommendations-bag-message">' +
            '<div class="close-variants-buttons-recommended">' + closeIcon + '</div>' +
            '<div class="variants-buttons-recommended">' + variantBtns + '</div>' +
          '</div>' +
          '<div class="cart-recommendations-buy-button-container">' +
            '<form style="display:none;"><input type="hidden" name="id" class="cart-recommendations-form-hidden" value="' + firstAvail.id + '"><input type="hidden" name="quantity" value="1"></form>' +
            '<add-to-cart class="cart-recommendations-button-add" data-variant-id="' + firstAvail.id + '" onclick="addToCartRecommended(this)">' +
              '<span class="cart-recommendations-text-button">Agregar al carro</span>' +
            '</add-to-cart>' +
            '<div class="select-size-button"><span class="cart-recommendations-text-button">Seleccionar talla</span></div>' +
          '</div>' +
        '</div>' +
      '</div>' +
    '</div>';
  }

  function initLazyRec(container) {
    if (container._lazyRecInited) return;
    container._lazyRecInited = true;

    var handle = container.dataset.handle;
    var limit = parseInt(container.dataset.limit) || 5;
    var total = parseInt(container.dataset.total) || 0;
    var page = parseInt(container.dataset.page) || 1;
    var table = container.querySelector('.cart-recommendations-table');
    var sentinel = container.querySelector('.cart-rec-sentinel');
    if (!table || !sentinel || !handle || total === 0) return;

    var loading = false;

    function isExhausted() {
      return page * limit >= total;
    }

    function loadMore() {
      if (loading || isExhausted()) return;
      loading = true;
      var nextPage = page + 1;

      fetch('/collections/' + handle + '/products.json?limit=' + limit + '&page=' + nextPage)
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = (data && data.products) || [];
          if (!products.length) {
            sentinel.remove();
            table.removeEventListener('scroll', onScroll);
            return;
          }
          var frag = document.createDocumentFragment();
          products.forEach(function (p) {
            var tmp = document.createElement('div');
            tmp.innerHTML = buildRecCard(p);
            if (tmp.firstChild) frag.appendChild(tmp.firstChild);
          });
          table.insertBefore(frag, sentinel);
          page = nextPage;
          container.dataset.page = String(page);
          loading = false;
          if (isExhausted()) {
            sentinel.remove();
            table.removeEventListener('scroll', onScroll);
          }
        })
        .catch(function () { loading = false; });
    }

    function onScroll() {
      if (table.scrollHeight - table.scrollTop - table.clientHeight < 150) {
        loadMore();
      }
    }

    table.addEventListener('scroll', onScroll);
  }

  function scanLazyRec() {
    document.querySelectorAll('cart-recommendations[data-lazy="true"]').forEach(initLazyRec);
  }

  new MutationObserver(scanLazyRec).observe(document.body, { childList: true, subtree: true });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scanLazyRec);
  } else {
    scanLazyRec();
  }
})();

// === BUNDLEBOX (bx-*) — formato CLP + color oferta ===
(function () {
  const SALE_COLOR = '#e83313';

  function formatClp(text) {
    const num = parseInt(text.replace(/\D/g, ''), 10);
    if (isNaN(num) || num <= 0) return text;
    return '$' + num.toLocaleString('es-CL');
  }

  function patchEl(el) {
    if (!el) return;
    const cleaned = formatClp(el.textContent.trim());
    if (el.textContent.trim() !== cleaned) el.textContent = cleaned;
  }

  function patchBx() {
    document.querySelectorAll('.bx-discounted-price, .bx-original-price, .js-bx-total-price').forEach(patchEl);

    document.querySelectorAll('.price-item[data-bx-tp]').forEach(function (priceEl) {
      const saleSpan = priceEl.querySelector('.bx-tp-flex > span:not(.bx-tp-compare)');
      const compareSpan = priceEl.querySelector('.bx-tp-compare');
      if (saleSpan) {
        patchEl(saleSpan);
        saleSpan.style.color = SALE_COLOR;
      }
      if (compareSpan) {
        patchEl(compareSpan);
        compareSpan.style.opacity = '';
        compareSpan.style.fontSize = '';
        compareSpan.style.color = '';
      }
    });
  }

  var _bxSyncing = false;

  function syncQtyToOffer(qty) {
    if (_bxSyncing) return;
    var offers = document.querySelectorAll('.js-bx-offer');
    if (!offers.length) return;
    var target = null;
    offers.forEach(function (offer) {
      var groups = offer.querySelectorAll('.js-bx-variant-group').length;
      if (groups === qty) target = offer;
    });
    if (!target || target.getAttribute('aria-checked') === 'true') return;
    _bxSyncing = true;
    target.click();
    setTimeout(function () { _bxSyncing = false; }, 300);
  }

  document.addEventListener('change', function (e) {
    if (_bxSyncing) return;
    var input = e.target;
    if (!input.classList.contains('quantity__input') && input.name !== 'quantity') return;
    syncQtyToOffer(parseInt(input.value, 10) || 1);
  });

  document.addEventListener('click', function (e) {
    if (_bxSyncing) return;
    var btn = e.target.closest('.quantity__button');
    if (!btn) return;
    var input = btn.closest('quantity-input, .quantity')?.querySelector('.quantity__input, input[name="quantity"]');
    if (!input) return;
    setTimeout(function () {
      syncQtyToOffer(parseInt(input.value, 10) || 1);
    }, 50);
  });

  new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var m = mutations[i];
      if (m.target && m.target.closest && (m.target.closest('.bx-widget') || m.target.closest('[data-bx-tp]'))) {
        patchBx(); return;
      }
      for (var j = 0; j < m.addedNodes.length; j++) {
        var node = m.addedNodes[j];
        if (node.nodeType === 1 && (
          node.classList.contains('bx-widget') ||
          (node.querySelector && (node.querySelector('.bx-widget') || node.querySelector('[data-bx-tp]')))
        )) {
          patchBx(); return;
        }
      }
    }
  }).observe(document.body, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', patchBx);
  } else {
    patchBx();
  }
})();

